import { ChangeDetectionStrategy, Component, input } from '@angular/core';

@Component({
  selector: 'ui-progress-bar',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [],
  template: `
    <div class="min-w-5 w-full" [class]="bgColorClass() + ' ' + 'rounded-full ' + height()">
      <div
        [class]="colorClass() + ' ' + height() + ' rounded-full'"
        [style.width.%]="progress() || 0"
      ></div>
    </div>
  `,
})
export class ProgressBarComponent {
  progress = input.required<number>();
  colorClass = input<string>('bg-blue');
  bgColorClass = input<string>('bg-gray-200');
  height = input<string>('h-2.5');
}
